import { FormikProvider, FormikProps } from 'formik';
import React, { FC } from 'react';
import { DeclarationFormCardProps } from 'views/declarations/common/declaration.form.card';
import { PartiesCardProps } from 'views/declarations/common/parties/PartiesCard';
import { MasterDetailsIrelandCardsType } from 'views/declarations/common/skeleton/card-type';
import {
    addCardToMultipleCards,
    deleteCardToMultipleCards,
    initializeMultipleCards,
} from 'views/declarations/utils/form-utils';
import { NestedAuthorisationCardProps } from './cards/authorisation-card/NestedAuthorisationCard';
import h1DeclarationSkeleton from './h1-skeleton-declaration';
interface Props {
    formik: FormikProps<any>;
    toggleHelp?: (refNumber: string | number) => void;
    viewOnly?: boolean;
    selectCard?: (id: string) => void;
}

const IrelandH1Form: FC<Props> = ({ formik, toggleHelp, viewOnly, selectCard }) => {
    const cardsOfMessageType = h1DeclarationSkeleton.cards;
    const cards = cardsOfMessageType.map((obj) => {
        if (obj.type === MasterDetailsIrelandCardsType.SINGLE) {
            const card = React.createElement(
                obj.component as React.FC<DeclarationFormCardProps>,
                {
                    getFields: obj.getFields,
                    getFieldProps: formik.getFieldProps,
                    getFieldMeta: formik.getFieldMeta,
                    getFieldHelpers: formik.getFieldHelpers,
                    toggleHelp: toggleHelp,
                    cardTotal: h1DeclarationSkeleton.cards.length,
                    cardNumber: obj.cardNumber,
                    defaultOpen: obj.defaultOpen,
                    keepOpen: obj.keepOpen,
                    keyCard: obj.key,
                    nestedComponents: obj.children,
                    key: obj.key,
                    propsPathPrefix: obj.propsPathPrefix,
                    viewOnly: viewOnly,
                    declarationType: obj.declarationType,
                    selectCard: selectCard,
                    formik: formik,
                },
                obj.key
            );
            return card;
        } else if (obj.type === MasterDetailsIrelandCardsType.NESTED_AUTHORIZATION) {
            const card = React.createElement(
                obj.component as React.FC<NestedAuthorisationCardProps>,
                {
                    getFields: obj.getFields,
                    getFieldProps: formik.getFieldProps,
                    getFieldMeta: formik.getFieldMeta,
                    getFieldHelpers: formik.getFieldHelpers,
                    toggleHelp: toggleHelp,
                    cardTotal: h1DeclarationSkeleton.cards.length,
                    cardNumber: obj.cardNumber,
                    defaultOpen: obj.defaultOpen,
                    keepOpen: obj.keepOpen,
                    keyCard: obj.key,
                    key: obj.key,
                    propsPathPrefix: obj.propsPathPrefix,
                    viewOnly: viewOnly,
                    nestedComponents: obj.children,
                    initializeList: (path) => initializeMultipleCards(formik, path),
                    addCard: (path, array) => {
                        addCardToMultipleCards(formik, path, array);
                    },
                    removeCard: (path, array, index) => deleteCardToMultipleCards(formik, path, array, index),
                    selectCard: selectCard,
                    formik: formik,
                },
                obj.key
            );
            return card;
        } else if (obj.type === MasterDetailsIrelandCardsType.PARTIES) {
            const card = React.createElement(
                obj.component as React.FC<PartiesCardProps>,
                {
                    getFieldProps: formik.getFieldProps,
                    getFieldMeta: formik.getFieldMeta,
                    getFieldHelpers: formik.getFieldHelpers,
                    toggleHelp: toggleHelp,
                    cardTotal: h1DeclarationSkeleton.cards.length,
                    cardNumber: obj.cardNumber,
                    defaultOpen: obj.defaultOpen,
                    keepOpen: obj.keepOpen,
                    keyCard: obj.key,
                    nestedComponents: obj.children,
                    key: obj.key,
                    propsPathPrefix: obj.propsPathPrefix,
                    viewOnly: viewOnly,
                    declarationType: obj.declarationType,
                    selectCard: selectCard,
                    parties: obj.other.parties,
                    paths: obj.other.paths,
                    condensed: obj.condensed,
                } as PartiesCardProps,
                obj.key
            );
            return card;
        } else return <></>;
    });

    return <FormikProvider value={formik}>{cards.map((obj) => obj)}</FormikProvider>;
};
export default IrelandH1Form;
